import { useMemo, useState } from 'react';
import { cn } from '@/utils/cn';
import OptimizedImage from '@/components/ui/OptimizedImage';
import Button from '@/components/ui/Button';

const FoodImageGallery = ({ images = [] as string[], title = 'Food item', compact = false }: { images?: string[]; title?: string; compact?: boolean }) => {
    const sanitizedImages = useMemo(() => (Array.isArray(images) ? images.filter(Boolean) : []), [images]);

    const [activeIndex, setActiveIndex] = useState(0);

    if (!sanitizedImages.length) {
        return (
            <div className={cn('food-gallery', compact && 'compact')}>
                <div className={cn('food-main-img-wrap', compact && 'compact')}>
                    <OptimizedImage
                        src="/assets/images/gallery/grid2/pic1.jpg"
                        alt={title}
                        className={cn('food-main-img', compact && 'compact')}
                        loading="eager"
                        fetchPriority="high"
                    />
                    <span className="food-main-badge">Fait Maison</span>
                </div>
            </div>
        );
    }

    const safeIndex = Math.min(activeIndex, sanitizedImages.length - 1);
    const activeImage = sanitizedImages[safeIndex];
    const thumbnailImages = sanitizedImages.slice(1);

    return (
        <div className={cn('food-gallery', compact && 'compact')}>
            <div className={cn('food-main-img-wrap', compact && 'compact')}>
                <OptimizedImage
                    src={activeImage}
                    alt={title}
                    className={cn('food-main-img', compact && 'compact')}
                    loading="eager"
                    fetchPriority="high"
                />
                <span className="food-main-badge">Fait Maison</span>
            </div>

            {!compact && thumbnailImages.length > 0 && (
                <div className="food-thumbnails">
                    {thumbnailImages.map((img, idx) => {
                        const originalIndex = idx + 1;
                        const isActive = originalIndex === safeIndex;

                        return (
                            <Button
                                key={`${img}-${originalIndex}`}
                                variant="ghost"
                                type="button"
                                className={cn('food-thumb-btn', isActive && 'is-active')}
                                onClick={() => setActiveIndex(originalIndex)}
                                aria-label={`Afficher image ${originalIndex + 1} de ${sanitizedImages.length}`}
                            >
                                <OptimizedImage src={img} alt={`${title} miniature ${originalIndex + 1}`} />
                            </Button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FoodImageGallery;
